module.exports = __webpack_public_path__ + "static/boat5-403354b52e5d52c568a9ad801bd0c6af.jpg";